import React, { useState, useEffect, useRef } from 'react';

const AudioPlayer = ({ src, onReset }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const modifiedUrl = src.replace("https://tecom.pro", "http://hustmedia.duckdns.org");
  const audioRef = useRef(null);

  // Handle play/pause toggle
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  // Handle reset button click
  const handleResetClick = () => {
    onReset(); // Notify parent component about reset
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false); // Reset play state
    }
  };

  // Automatically load new audio when src changes
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.load(); // Reload audio element with the new source
    }
  }, [src]);

  return (
    <>
      <div>
        <button
          onClick={togglePlay}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          {isPlaying ? 'Pause' : 'Play'}
        </button>
        <button
          onClick={handleResetClick}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Reset
        </button>
        <a href={modifiedUrl} target="_blank" rel="noopener noreferrer">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Tải
          </button>
        </a>
      </div>

      <audio
        controls
        ref={audioRef}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
      >
        <source src={src} />
        Your browser does not support the audio element.
      </audio>
    </>
  );
};

export default AudioPlayer;
